<template>
  <div>
    <AppTag
      v-for="(calve, index) in bovine.calves.slice(0, 2)"
      :key="index"
      :style="getStyles(calve)"
    >
      <span class="material-icons">local_offer</span> {{ getText(calve) }}
    </AppTag>
  </div>
</template>

<script>
import { bovineColors } from '../../../lib/bovines';

export default {
  name: 'BovineCalvesTags',
  props: {
    bovine: Object,
    inactive: Boolean,
  },
  methods: {
    getText(calve) {
      const parts = [calve.earring, calve.type.name];
      if (calve.birthDate) {
        parts.push(this.getMonthText(calve));
      }
      return parts.join(' - ');
    },
    getMonthText(calve) {
      const count = this.$dayjs().diff(calve.birthDate, 'M');
      return `${count || 1} ${count > 1 ? 'meses' : 'mês'}`;
    },
    getStyles(calve) {
      return {
        ...(this.inactive ? { filter: 'grayscale(100%)' } : {}),
        ...(bovineColors[calve.type?.id] || {}),
      };
    },
  },
};
</script>

<style scoped>
p {
  display: inline-block;
  margin: 0 5px 5px 0;
  font-weight: 700;
}

.material-icons {
  font-size: 14px;
  vertical-align: top;
  padding-top: 1px;
}
</style>
